import BaseCollection from "lib/collection";
import BrandUserModel from "models/brand/brand-user";

export default BaseCollection.extend({
    mainIndex: "ref",
    indexes: ["_id"],
    model: BrandUserModel,
});
